angular.module('impactx.list').service('ListHelperService', ListHelperService);

//ListHelperService.$inject = ['$window', '$config', '$securityManager'];

/**
 * Service to help with lists of different kind.
 * @constructor
 */
function ListHelperService() {

    /**
     * Refreshes a list.
     *
     * @param listScope scope of the list
     * @param subListName name of the sub-list to refresh
     * @param options (optional) additional options for the refreshing of the list
     */
    this.refreshListData = function(listScope, subListName, options) {

        if(listScope && subListName) {
            //DIRTY, but what else ? No real clean communication with lists...
            if(impactX.isFunction(listScope, subListName + '.meta.refreshListData')) {
                listScope[subListName].meta.refreshListData(options);
            }
        }
    };
}
